import loglevel from 'loglevel';
import { apiDateFormatter, queryString } from 'lib/format';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';
import appConfig from '../../../config';

const log = loglevel.getLogger('WatchAPI');
const watchApiConfig = appConfig.watchApi;

const DEFAULT_CONFIGURATION = {
    serviceUrl: 'http://api-app.espn.com/v1/watch',
    internalServiceUrl:'http://sports-bc.prod.espninfra.starwave.com/espn360/apis/v1/watch',
    apiKey: '',
    networks: 'espn1,espn2,espn3,espnu,sec,secplus,espnews,espndeportes,longhorn,goalline,buzzerbeater,acc,accextra,secplus',
    resultsLimit: 200
};

const config = { ...DEFAULT_CONFIGURATION, ...watchApiConfig };

export function getListings({ types, networks, categories, subcategories, dates, limit = config.resultsLimit }, baseUrl = `${config.serviceUrl}/listings`) {
    const typesQuery = types ? types.join(',') : '';
    const networksQuery = (networks === '') ? config.networks : null;
    const categoriesQuery = categories ? categories.join(',') : '';
    const subcategoriesQuery = subcategories ? subcategories.join(',') : '';
    const datesQuery = dates ? apiDateFormatter(...dates) : 0;
    const limitQuery = limit;

    const qs = queryString({ types: typesQuery, networks: networksQuery, categories: categoriesQuery, subcategories: subcategoriesQuery, dates: datesQuery, limit: limitQuery });
    // if a baseUrl is passed in, it could potentially already have queryParamters.  Need to replace ? with & if so
    const url = (baseUrl.indexOf('?') !== -1) ? `${baseUrl}${qs.replace('?', '&')}` : `${baseUrl}${qs}`;

    log.debug(`getClient: ${url}`);
    return request(url)
        .use(proxy)
        .then((response) => {
            const listings = response.body.listings || [];
            fallback.set(url, listings);
            return listings;
        })
        .catch((err) => {
            log.error('getListings:', err.originalError);
            return fallback.get(url);
        });
}

export function getTopCategories() {
    const url = `${config.serviceUrl}/categories/top`;

    return request(url)
        .use(proxy)
        .then((response) => {
            const categories = response.body.categories || [];
            fallback.set(url, categories);
            return categories;
        })
        .catch((err) => {
            log.error('getTopCategories:', err.originalError);
            return fallback.get(url);
        });
}

export function getCategories() {
    const url = `${config.serviceUrl}/categories`;

    return request(url)
        .use(proxy)
        .then((response) => {
            const categories = response.body.categories || [];
            fallback.set(url, categories);
            return categories;
        })
        .catch((err) => {
            log.error('getCategories:', err.originalError);
            return fallback.get(url);
        });
}



// WEBPACK FOOTER //
// ./app/lib/api/WatchAPI.js